import { render, staticRenderFns } from "./Announce.vue?vue&type=template&id=2a6f516c&scoped=true"
import script from "./Announce.vue?vue&type=script&lang=ts"
export * from "./Announce.vue?vue&type=script&lang=ts"
import style0 from "./Announce.vue?vue&type=style&index=0&id=2a6f516c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6f516c",
  null
  
)

export default component.exports